import crypto from "crypto";

export enum EcwFileContentType {
  PDF = "application/pdf",
  OCTET_STREAM = "application/octet-stream",
}

export enum EcwMultipartPartKind {
  FIELD = "field",
  FILE = "file",
}

export type EcwMultipartPart =
  | { kind: EcwMultipartPartKind.FIELD; name: string; value: string }
  | { kind: EcwMultipartPartKind.FILE; name: string; filename: string; contentType: EcwFileContentType; data: Buffer };

export function serializeMultipart(parts: EcwMultipartPart[]): { data: Buffer; contentTypeHeader: string } {
  const boundary = "----NodeFormBoundary" + crypto.randomBytes(8).toString("hex");
  const CRLF = "\r\n";
  const chunks: Array<Buffer | string> = [];

  for (const part of parts) {
    chunks.push(`--${boundary}${CRLF}`);
    if (part.kind === EcwMultipartPartKind.FILE) {
      chunks.push(`Content-Disposition: form-data; name="${part.name}"; filename="${part.filename}"${CRLF}`);
      chunks.push(`Content-Type: ${part.contentType}${CRLF}${CRLF}`);
      chunks.push(part.data);
      chunks.push(CRLF);
    } else {
      chunks.push(`Content-Disposition: form-data; name="${part.name}"${CRLF}`);
      chunks.push(`Content-Type: text/plain; charset=UTF-8${CRLF}${CRLF}`);
      chunks.push(part.value);
      chunks.push(CRLF);
    }
  }

  chunks.push(`--${boundary}--${CRLF}`);

  return {
    data: Buffer.concat(chunks.map((c) => (Buffer.isBuffer(c) ? c : Buffer.from(c, "utf8")))),
    contentTypeHeader: `multipart/form-data; boundary=${boundary}`,
  };
}
